'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Pagination = require('../Pagination');

var _Pagination2 = _interopRequireDefault(_Pagination);

var _Table = require('../Table');

var _Table2 = _interopRequireDefault(_Table);

var _RenderIf = require('../RenderIf');

var _RenderIf2 = _interopRequireDefault(_RenderIf);

var _options = require('./options');

var _options2 = _interopRequireDefault(_options);

var _getPageItems = require('./helpers/getPageItems');

var _getPageItems2 = _interopRequireDefault(_getPageItems);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * It implement a client side pagination experience. It basically wire up the Table and
 * the Pagination component in a compose manner and keep the internal state of the active page
 * based on a new prop `pageSize`.
 * @category DataView
 */


var TableWithBrowserPagination = function (_React$Component) {
  _inherits(TableWithBrowserPagination, _React$Component);

  function TableWithBrowserPagination(props) {
    _classCallCheck(this, TableWithBrowserPagination);

    var _this = _possibleConstructorReturn(this, (TableWithBrowserPagination.__proto__ || Object.getPrototypeOf(TableWithBrowserPagination)).call(this, props));

    var data = props.data,
        pageSize = props.pageSize;
    _this.state = {
      activePage: 1,
      pageItems: (0, _getPageItems2["default"])({
        data: data,
        activePage: 1,
        pageSize: pageSize
      })
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleSelectChange = _this.handleSelectChange.bind(_this);
    _this.table = _react2["default"].createRef();
    return _this;
  }

  _createClass(TableWithBrowserPagination, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          data = _props.data,
          pageSize = _props.pageSize;

      if (prevProps.data !== data || prevProps.pageSize !== pageSize) {
        this.updateData();
      }
    }
  }, {
    key: 'getPaginationContainerClassNames',
    value: function getPaginationContainerClassNames() {
      var paginationAlignment = this.props.paginationAlignment;
      return (0, _classnames2["default"])('rainbow-table-with-browser-pagination_pagination-container', 'rainbow-table-with-browser-pagination_pagination--' + paginationAlignment);
    }
  }, {
    key: 'updateData',
    value: function updateData() {
      var _props2 = this.props,
          data = _props2.data,
          pageSize = _props2.pageSize;
      var activePage = this.state.activePage;
      var totalPages = Math.ceil(data.length / pageSize);
      var nextActivePage = activePage <= totalPages ? activePage : 1;
      this.setState({
        activePage: nextActivePage,
        pageItems: (0, _getPageItems2["default"])({
          data: data,
          activePage: nextActivePage,
          pageSize: pageSize
        })
      });
    }
  }, {
    key: 'moveToPage',
    value: function moveToPage(page) {
      var _props3 = this.props,
          data = _props3.data,
          pageSize = _props3.pageSize;
      this.setState({
        activePage: page,
        pageItems: (0, _getPageItems2["default"])({
          data: data,
          activePage: page,
          pageSize: pageSize
        })
      });
      this.table.current.scrollTop();
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event, page) {
      this.moveToPage(page);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(event) {
      var page = Number(event.target.value);
      this.moveToPage(page);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          style = _props4.style,
          className = _props4.className,
          paginationAlignment = _props4.paginationAlignment,
          pageSize = _props4.pageSize,
          data = _props4.data,
          children = _props4.children,
          rest = _objectWithoutProperties(_props4, ['style', 'className', 'paginationAlignment', 'pageSize', 'data', 'children']);

      var _state = this.state,
          activePage = _state.activePage,
          pageItems = _state.pageItems;
      var pages = Math.ceil(data.length / pageSize);
      var showPagination = pages > 1;
      return _react2["default"].createElement('div', {
        className: className,
        style: style
      }, _react2["default"].createElement(_Table2["default"], _extends({
        className: 'rainbow-table-with-browser-pagination_table',
        data: pageItems
      }, rest, {
        ref: this.table
      }), children), _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: showPagination
      }, _react2["default"].createElement('div', {
        className: this.getPaginationContainerClassNames()
      }, _react2["default"].createElement(_Pagination2["default"], {
        pages: pages,
        activePage: activePage,
        onChange: this.handleChange
      }), _react2["default"].createElement(_RenderIf2["default"], {
        isTrue: pages > 6
      }, _react2["default"].createElement('div', {
        className: 'rainbow-table-with-browser-pagination_select-container'
      }, _react2["default"].createElement('select', {
        className: 'rainbow-table-with-browser-pagination_select',
        onChange: this.handleSelectChange,
        value: activePage
      }, _react2["default"].createElement(_options2["default"], {
        pages: pages
      })))))));
    }
  }]);

  return TableWithBrowserPagination;
}(_react2["default"].Component);

exports["default"] = TableWithBrowserPagination;
TableWithBrowserPagination.propTypes = {
  /** Determines the alignment of the pagination relative to the container.
   * Available options are: center, left, and right.
   * This value defaults to center. */
  paginationAlignment: _propTypes2["default"].oneOf(['center', 'left', 'right']),

  /** Indicates the amount of data that will be showed per page. */
  pageSize: _propTypes2["default"].number,

  /** An array containing the objects(rows) to be displayed. */
  data: _propTypes2["default"].array,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes2["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes2["default"].object
};
TableWithBrowserPagination.defaultProps = {
  paginationAlignment: 'center',
  className: undefined,
  style: undefined,
  pageSize: Infinity,
  data: []
};